import styled from "@emotion/styled";

const StyledDiv = styled.div`
  /* border: 2px solid red; */

  min-height: calc(100vh - 4rem);
  width: 100%;
  margin-top: 4rem;
  background-color: #fcfcfc;
  padding-bottom: 2.4rem;

  .page-header {
    /* border: 2px solid lightblue; */
    font-family: "Roboto";
    font-weight: 500;
    font-size: 1.6rem;
    margin: 1.6 auto 0 auto;

    .header-bold {
      color: #00a5e0;
    }
  }

  .form-page-container {
    /* border: 2px solid blue; */

    padding: 1.2rem;

    width: fit-content;
    /* margin: 4.5rem auto; */
    margin: auto;
  }

  .skeleton-container {
    /* border: 2px solid peru; */
    box-sizing: border-box;
    height: 56px;
  }

  .phone-input {
    width: 100%;
  }

  .form-page-title {
  }

  .form-input-container {
    /* border: 2px solid green; */

    width: 700px;
    gap: 1.2rem;

    display: flex;
    flex-direction: row;
    margin-left: auto;
    margin-right: auto;
  }

  .form-page-title {
    font-family: "Roboto";
    font-weight: 400;
    font-size: 1.6rem;
  }

  .form-input-section {
    /* border: 2px solid brown; */

    width: 50%;

    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .submit-button {
    margin-top: 0.8rem;
    width: 25%;
  }

  .tos-container {
    margin-top: 1.2rem;
    /* border: 2px solid pink; */
    width: fit-content;

    display: flex;
    align-items: center;
    justify-content: center;

    /* gap: 0.8rem; */
    font-family: Roboto;
    font-size: 0.9rem;
    margin-left: auto;
    margin-right: auto;

    .tos-link {
      color: #1769aa;
      cursor: pointer;
      font-weight: 700;
    }
  }

  .contract-modal {
    border: 2px solid blue;
  }

  h5 {
    color: #808080;
    font-weight: 500;
    margin: 0.7rem auto;
    background-color: #e8e8e8;
    border-radius: 0.5rem;
    padding: 1.2rem;
  }

  @media (max-width: 768px) {
    .form-input-container {
      /* border: 2px solid blue; */
      flex-direction: column;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
    .form-input-section {
      /* border: 2px solid purple; */
      width: 100%;
    }
    .submit-button {
      width: 100%;
    }
  }
`;

export default StyledDiv;
